/* Company Confidential, Copyright (c) 2017 CRF Box, Ltd. All Rights Reserved. */

export const PARTICIPANT_STATUS = {
  CONSENTED: 'Consented',
  ABORTED: 'Declined to participate',
  WAITING_CONSENT: 'Awaiting consent',
  WAITING_RECONSENT: 'Needs to reconsent',
  STUDY_COMPLETED: 'Completed the study',
  STUDY_TERMINATED: 'Withdrawn from the study',
  WITHDRAWN_CONSENT: 'Withdrawn consent',
  FAILED_SCREENING: 'Failed screening'
};
